




























































import { Component, Vue, Prop } from "vue-property-decorator";
import vesselsAdminClient from "@/Scripts/clients/vessels-administrations-client";

@Component
export default class VesselNotes extends Vue {
  @Prop({ required: true }) vesselId!: number;

  notes = "";
  error: string | null = null;
  isLoading = false;
  isSaving = false;
  vessel: any = undefined;

  async mounted(): Promise<void> {
    await this.loadVesselNotes();
  }

  async loadVesselNotes(): Promise<void> {
    this.clearError();
    this.isLoading = true;

    try {
      const data = await vesselsAdminClient.get(this.vesselId);
      this.initialize(data);
    } catch (error) {
      this.setError("Failed to load data.", error);
      this.initialize(undefined);
    } finally {
      this.isLoading = false;
    }
  }

  async saveVesselNotes(): Promise<void> {
    this.clearError();

    if (this.notes !== undefined && this.vessel) {
      const vessel = { ...this.vessel };
      vessel.notes = this.notes;
      this.isSaving = true;

      try {
        const data = await vesselsAdminClient.update(vessel);
        this.initialize(data);
      } catch (error) {
        this.setError("Failed to save data.", error);
      } finally {
        this.isSaving = false;
      }
    }
  }

  initialize(vessel: any): void {
    this.vessel = vessel;
    if (this.vessel) {
      this.notes = this.vessel.notes || "";
    } else {
      this.notes = "";
    }
  }

  clearError(): void {
    this.error = null;
  }

  setError(errorText: string, error: any): void {
    this.error = errorText;
    console.error(errorText);
    console.error(error);
  }
}
